export const instagramUrl = "https://www.instagram.com/airyvibela?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
export const redbookUrl = "https://www.xiaohongshu.com/user/profile/5e4c8bcb0000000001003e46?xhsshare=CopyLink&appuid=5e4c8bcb0000000001003e46&apptime=1711423952"
export const ronWechat = "hr674255192"
export const email = "airyvibela@gmail.com"